import { render, staticRenderFns } from "./MagicPageDesigner.vue?vue&type=template&id=0b5637b6&"
import script from "./MagicPageDesigner.vue?vue&type=script&lang=js&"
export * from "./MagicPageDesigner.vue?vue&type=script&lang=js&"
import style0 from "./MagicPageDesigner.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports